export class AdditionalFieldDto {
  constructor(
    public code?: string,
    public value?: string) { }
}
